<template>
	<div id="modal-wrapper">
		<modal-component ref="modal" :anotherBackground="true" @onModalClose="this.$emit('onModalClose')">
			<div id="discount-gratuity-modal" class="modal-container">
				<div class="modal-header">{{ 'Gratuity' ===  title ? 'Tip' : title }}</div>
				
				<div class="sets" :style="{padding: title === 'All discounts' ? '0px 42px' : '0px'}">
					<div class="inputs">
						<div v-if="title === 'All discounts'" class="fidelio">
							<p v-if="title === 'All discounts'">Fidelio check discount, $:</p>
							<p v-if="title === 'All discounts'">{{ fidelioDiscount }}</p>
						</div>
						
						<div class="manual" @click="setActiveInput('order', 0)">
							<label v-if="title !== 'Gratuity'" for="mv">Manual discount, {{ manualDiscountType }}:</label>
							<label v-if="title === 'Gratuity'" for="mv">Additional Tip:</label>
							<div class="input_disc_group">
								<input v-if="title === 'Gratuity'" id="mv" type="text" v-model="manualValue" @keypress="isNumber($event)" :placeholder="this.manualGratuityType !== '%' ? placeHoldA : placeHoldP">
								<input v-if="title === 'All discounts'" id="mv" type="text" v-model="manualValue" @keypress="isNumber($event)" :placeholder="manualDiscountType !== '%' ? placeHoldA : placeHoldP">
								<input v-if="title === 'Item discount'" id="mv" type="text" v-model="manualValue" @keypress="isNumber($event)" :placeholder="manualDiscountType !== '%' ? placeHoldA : placeHoldP">

								<Switch
									:class="'md_box__sw switch_item-discount twoside ' + design"
									:id="'switch_orederDiscount'"
									:val="title === 'Gratuity' ? manualGratuityTypeBool : manualDiscountTypeBool"
									:onLabel="'$'"
									:offLabel="'%'"
									@toggled="toggleManualDiscountType"
								/>
							</div>
						</div>
					</div>
				</div>

				<div v-if="title === 'All discounts'" class="discounts-table">
					<table class="table">
						<thead>
						<tr>
							<th class="th-name">ITEM</th>
							<th class="th-price">PRICE</th>
							<th class="th-q">QTY</th>
							<!-- <th class="th-fd">FIDELIO DISCOUNT</th> -->
							<th class="th-md">MANUAL DISCOUNT</th>
						</tr>
						</thead>
						<tbody>
						<tr
              v-if="itemsDiscounts.length"
              v-for="(orderItem, orderItemIdx) in selectedOrder.items"
              :key="orderItemIdx"
            >
							<td class="td-name">{{ orderItem.name }}</td>
							<td>{{ orderItem.price.toFixed(2) }}</td>
							<td>{{ orderItem.count }}</td>
							<!-- <td>{{ itemDiscount(i) }}</td> -->
							<td class="td-md">
								<div class="md_box" @click="setActiveInput('item', orderItemIdx)">
									<input
                    v-model="itemsDiscounts[orderItemIdx].m_discount_amount"
                    class="md_box__ti"
                    type="text"
                    :placeholder="itemsDiscounts[orderItemIdx].typeBool ? placeHoldA : placeHoldP"
                  >

									<Switch
                    :key="`${itemsDiscounts[orderItemIdx].id}-${itemsDiscounts[orderItemIdx].typeBool}`"
										:class="'md_box__sw switch_item-discount twoside ' + design"
										:id="'switch_item '+orderItemIdx"
										:val="itemsDiscounts[orderItemIdx].typeBool"
										:onLabel="'$'"
										:offLabel="'%'"
										@toggled="toggleManualItemDiscountType"
									/>
									<!-- {{ i.discount.toFixed(2) }} -->
								</div>
							</td>
						</tr>
						</tbody>
					</table>
					<!-- <div class="total">
						TOTAL DISCOUNT: <span>${{ fidelioDiscount }}</span>
					</div> -->
				</div>

				<keypad
					@clickOnKey="keypadClick"
					@clear="keypadClear"
				></keypad>

				<div class="modal-controls">
					<base-button text="CANCEL" classes="def-btn cancel-action-btn uppercase medium border-2" @onClick="closeModal()"/>

          <base-button
            :text="okButtonLabel"
            classes="def-btn main-action-btn uppercase medium border-2"
            @onClick="confirm"
          />
				</div>
			</div>
		</modal-component>
	</div>
</template>

<script>
import ModalComponent from "@/components/_shared/Modal";
import Keypad from "@/components/_shared/Keypad";
import Switch from "@/components/_shared/Switch.vue";
import BaseButton from "@/components/_shared/Button.vue";
import { constants } from '@/constants/constants';
import { calculateItemDiscount } from '@/_helpers/order';

export default {
	name: 'SetDiscountGratuityModalComponent',
	props: {
		selectedOrder: {
			default: null,
			required: true
		}
	},
	emits: ['changeItemDiscount', 'changeOrderDiscount', 'changeGratuity', 'onModalClose'],
	components: {BaseButton, ModalComponent, Keypad, Switch},
	data() {
		return {
			title: '',
			manualValue: '',
			activeInput: null,
			itemsDiscounts: [],
			includedGratuity: false,
			manualGratuityTypeBool: true,
			manualGratuityType: '',
			manualDiscountTypeBool: true,
			manualDiscountType: '',
			singleItemIndex: null,
			placeHoldA: '0.00',
			placeHoldP: '0',
		}
	},
	computed: {
    isItemDiscountLevel() {
      return this.selectedOrder?.department?.discount_level !== 2;
    },

    design() {
			return this.$store.state.UI;
		},
		itemsWithDiscount() {
			return this.selectedOrder.items.filter((o) => {return o.m_discount_amount});
		},
		fidelioDiscount() {
			let fidelioDiscount = 0;
			return fidelioDiscount.toFixed(2);
		},

    okButtonLabel() {
      return this.title === 'All discounts'
        ? 'save'
        : 'ok';
    },
	},
	created() {},
	mounted() {},
	beforeUnmount() {
		this.emmiter.emit('toggleModals', {opened: false, type: 'SetDiscountGratuityModal'});
	},
	methods: {
		setActiveInput(inp, ind) {
			if (this.title !== 'All discounts') {
				return;
			};
			this.activeInput = {name: inp, ind: ind};
		},
    getDiscountSign(type) {
      return constants.discountTypes.amount === type
        ? '$'
        : '%';
    },
		setValues() {
			if (this.title === 'Gratuity') {
				this.manualGratuityTypeBool = this.selectedOrder.gratuity_type !== constants.gratuityTypes.percentage;
        const gratuityValue = this.selectedOrder.gratuity_type === constants.gratuityTypes.amount
          ? (this.selectedOrder.gratuity_amount ? this.selectedOrder.gratuity_amount.toString() : '')
          : this.selectedOrder.gratuity_percent.toString();

        this.manualValue = '0.00' !== gratuityValue ? gratuityValue : '';
				this.manualGratuityType = this.selectedOrder.gratuity_type === constants.gratuityTypes.amount
          ? '$'
          : '%';
			}

			if (this.title === 'Item discount') {
        this.manualDiscountType = this.getDiscountSign(this.selectedOrder?.items?.[this.singleItemIndex]?.m_discount_type);
        this.manualDiscountTypeBool = '$' === this.manualDiscountType;

        const itemDiscountValue = calculateItemDiscount(this.selectedOrder?.items?.[this.singleItemIndex]);

        this.manualValue = '0.00' !== itemDiscountValue ? itemDiscountValue : '';

      }

      if (this.title === 'All discounts') {
        const allDiscountValue = calculateItemDiscount(this.selectedOrder);

        this.manualValue = '0.00' !== allDiscountValue ? allDiscountValue : '';

        if (this.isItemDiscountLevel) {
          this.manualValue = this.selectedOrder.items_discount_value;
          this.manualDiscountType = this.getDiscountSign(this.selectedOrder.items_discount_type);
        } else {
          this.manualDiscountType = this.getDiscountSign(this.selectedOrder?.m_discount_type);
        }

        this.manualDiscountTypeBool = '$' === this.manualDiscountType;

        setTimeout(() => {
          this.selectedOrder.items.forEach((item) => {
            const typeSign = this.getDiscountSign(item.m_discount_type);

            const discountAmount = calculateItemDiscount(item);
            this.itemsDiscounts.push({
              price: item.price,
              m_discount_amount: '0.00' !== discountAmount ? discountAmount : '',
              typeBool: '$' === typeSign,
              type: typeSign,
            });
          });
        }, 10);
      }
		},

    getDiscountType(type) {
      return '%' === type
        ? constants.discountTypes.percentage
        : constants.discountTypes.amount;
    },

    getDiscountFieldKey(type) {
      return '%' === type
        ? 'm_discount_percentage'
        : 'm_discount_amount';
    },

    confirmAllDiscount() {
      const orderDiscountType = this.getDiscountType(this.manualDiscountType)
      if (this.isItemDiscountLevel) {
        this.selectedOrder.items_discount_value = this.manualValue ?? 0;
        this.selectedOrder.items_discount_type = orderDiscountType;

        this.selectedOrder.m_discount_percentage = 0;
        this.selectedOrder.m_discount_amount = 0;
        this.selectedOrder.m_discount_type = orderDiscountType;
      } else {
        this.selectedOrder.items_discount_value = null;
        this.selectedOrder.items_discount_type = null;

        const fieldKey = this.getDiscountFieldKey(this.manualDiscountType);

        this.selectedOrder[fieldKey] = this.manualValue ?? 0;
        this.selectedOrder.m_discount_type = orderDiscountType;
      }

      this.itemsDiscounts.forEach((orderItem, orderItemIdx) => {
        const itemDiscountFieldKey = this.getDiscountFieldKey(orderItem.type);

        this.selectedOrder.items[orderItemIdx][itemDiscountFieldKey] = +orderItem.m_discount_amount ?? 0;
        this.selectedOrder.items[orderItemIdx].m_discount_type = this.getDiscountType(orderItem.type);
      });

      this.$emit('changeOrderDiscount',	this.selectedOrder);
    },

    confirmItemDiscount() {
      const discountFieldKey = this.getDiscountFieldKey(this.manualDiscountType);

      this.selectedOrder.items[this.singleItemIndex][discountFieldKey] = this.manualValue ?? 0;
      this.selectedOrder.items[this.singleItemIndex].m_discount_type = this.getDiscountType(this.manualDiscountType);

      this.$emit('changeItemDiscount',	this.selectedOrder.items[this.singleItemIndex]);
    },

    confirmGratuity() {
      let data = {};

      let type = this.manualGratuityType === '$' ? 'amount' : 'percentage';

      data['gratuity_type'] = type;
      if (type === 'amount') {
        data['gratuity_amount'] = +this.manualValue;
      } else if (type === 'percentage') {
        data['gratuity_percent'] = +this.manualValue;
      };
      if (data['gratuity_type'] === 'percentage' && data['gratuity_percent'] === 0) {
        data['gratuity_type'] = 'amount';
        data['gratuity_amount'] = 0;
      };
      this.$emit('changeGratuity', data);
    },

		confirm() {
      switch (this.title) {
        case 'Item discount':
          this.confirmItemDiscount();
          break;
        case 'All discounts':
          this.confirmAllDiscount();
          break;
        case 'Gratuity':
          this.confirmGratuity();
          break;
      }

      this.$refs['modal'].close();
		},
		isNumber(e) {
			e = (e) ? e : window.event;
			let charCode = (e.which) ? e.which : e.keyCode;
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
				e.preventDefault();
			} else {
				// this.manualValue += e.key;
				return true;
			}
		},
		itemDiscount(item) {
			let condimentsDiscount = 0;
			if (item.condiments && item.condiments.length) {
				item.condiments.forEach((o) => {
					if (o.count > 0) {
						condimentsDiscount += o.m_discount_amount;
					}
				})
			} else {
				if (item.items && item.items.length) {
					item.items.forEach((o) => {
						if (o.condiments && o.condiments.length) {
							o.condiments.forEach((oo) => {
								if (oo.count > 0) {
									condimentsDiscount += oo.m_discount_amount;
								}
							});
						}
					});
				}
			}
			return (item.subtotal - item.total + condimentsDiscount).toFixed(2);
		},
		openModal(data) {
			this.$refs['modal'].show();
			if (data) {
				if (data.index || data.index === 0) {
					this.singleItemIndex = data.index;
				};
				this.title = data.title;
				this.setValues();
			};
			this.emmiter.emit('toggleModals', {opened: true, type: 'SetDiscountGratuityModal'});
		},
		closeModal() {
			this.emmiter.emit('toggleModals', {opened: false, type: 'SetDiscountGratuityModal'});
			this.$refs['modal'].close();
		},
		keypadClick(e) {
			// if ((this.manualGratuityType === '$' && this.manualValue === '0.00') || (this.manualGratuityType === '%' && this.manualValue === '0')) {
			// 	this.manualValue = '';
			// };
			if (this.activeInput?.name === 'item') {
				this.itemsDiscounts[this.activeInput.ind].m_discount_amount += e.toString();
			} else {
				this.manualValue += e.toString();
			}
		},
		keypadClear() {
			if (this.activeInput?.name === 'item') {
				this.itemsDiscounts[this.activeInput.ind].m_discount_amount = this.itemsDiscounts[this.activeInput.ind].m_discount_amount.slice(0, -1);
			} else {
				this.manualValue = this.manualValue.slice(0, -1)
			}
		},
		toggleGratuity(val) {
			this.includedGratuity = val;
		},
		toggleManualItemDiscountType(value) {
			setTimeout(() => {
				this.itemsDiscounts[this.activeInput.ind].typeBool = value;
				this.itemsDiscounts[this.activeInput.ind].m_discount_amount = '';
				if (value) {
					this.itemsDiscounts[this.activeInput.ind].type = '$';
				} else {
					this.itemsDiscounts[this.activeInput.ind].type = '%';
				}
			}, 10);
		},
		toggleManualDiscountType(value) {
			setTimeout(() => {
				if(this.title === 'Gratuity') {
					this.toggleManualGratuityType(value)
					return
				};
				this.manualDiscountTypeBool = value;
				this.manualValue = '';
				if (value) {
					this.manualDiscountType = '$';
				} else {
					this.manualDiscountType = '%';
				}
			}, 0);
		},
		toggleManualGratuityType(val) {
			this.manualValue = '';
			if (val) {
				this.manualGratuityType = '$';
			} else {
				this.manualGratuityType = '%';
			}
		},

    changeItemsDiscounts() {
      if (this.title === 'All discounts' && this.isItemDiscountLevel) {
        this.itemsDiscounts.forEach((orderItem, orderItemIdx) => {
          this.itemsDiscounts[orderItemIdx].typeBool = '$' === this.manualDiscountType;

          this.itemsDiscounts[orderItemIdx].type = this.manualDiscountType;

          if ('%' === this.manualDiscountType) {
            this.itemsDiscounts[orderItemIdx].m_discount_amount = this.manualValue ?? 0;

            return;
          }

          let discountAmount = 0;
          try {
            discountAmount = ((this.selectedOrder.items[orderItemIdx].subtotal + this.selectedOrder.items[orderItemIdx].condiments_amount) / this.selectedOrder.original_subtotal) * this.manualValue;
          } catch (error) {}

          this.itemsDiscounts[orderItemIdx].m_discount_amount = discountAmount > 0 ? discountAmount.toFixed(2) : 0;
        });
      }
    },
	},
	watch: {
    manualValue() {
      this.changeItemsDiscounts();
    },

    manualDiscountType() {
      this.changeItemsDiscounts();
    },
  }
}
</script>

<style lang="less" scoped>
#modal-wrapper {
	.window {
		background-color: #F5F9FC !important;
	}
	
	#discount-gratuity-modal {
		width: 600px;
		background-color: #F5F9FC;
		
		.modal-header {
			font-style: normal;
			font-weight: 300;
			font-size: 42px;
			line-height: 56px;
			text-align: center;
			color: #3F8EC5;
		}
		
		.sets {
			width: 100%;
			display: flex;
			flex-direction: row;
			gap: 18px;
			margin-bottom: 26px;
			
			.inputs {
				flex: 4;
				flex-direction: column;
				
				.fidelio {
					padding: 3px;
					width: 100%;
					height: 40px;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;
					background-color: #fff;
					margin-bottom: 24px;
					
					p {
						padding: 0;
						width: max-content;
						font-style: normal;
						font-weight: 600;
						font-size: 14px;
						line-height: 16px;
						color: #1C282D;
					}
				}
				
				.manual {
					width: 100%;
					display: flex;
					flex-direction: column;
					align-items: flex-start;
					gap: 4px;
					
					label {
						padding: 0;
						width: max-content;
						font-style: normal;
						font-weight: 600;
						font-size: 14px;
						line-height: 16px;
						color: #1C282D;
					}
					
					.input_disc_group {
						width: 100%;
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: space-between;
						gap: 8px;

						input {
							box-sizing: border-box;
							padding: 3px;
							width: 100%;
							height: 40px;
							background-color: #fff;
							border: none;
							border-bottom: 2px solid #3F8EC5;
							font-style: normal;
							font-weight: 400;
							font-size: 18px;
							line-height: 20px;
							color: #1C282D;
						}
					}
				}
			}
			
			.switches {
				padding: 4px 0;
				width: max-content;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
			}
		}
		
		.discounts-table {
			width: 100%;
			padding: 0;
			box-sizing: border-box;
			max-height: 400px;
			overflow-x: auto;
			
			.table {
				width: 100%;
				table-layout: fixed;
				border-collapse: collapse;
				box-sizing: border-box;
				text-align: left;
				background-color: #fff;
				
				thead {
					font-style: normal;
					font-weight: 600;
					font-size: 12px;
					color: #1C282D;
					
					tr {
						height: 36px;
						
						th {
							border: 1px solid #E5E0EB;
							border-top: 2px solid #E5E0EB;
							border-bottom: 2px solid #E5E0EB;
							padding: 2px;
							text-align: center;
						}
						
						.th-name {
							width: 30%;
							border-left: none;
						}
						
						.th-price {
							width: 15%;
						}
						
						.th-q {
							width: 15%;
						}
						
						.th-fd {
							width: 15%;
						}
						
						.th-md {
							width: 40%;
							border-right: none;
						}
					}
					
				}
				
				tbody {
					font-style: normal;
					font-weight: 400;
					font-size: 14px;
					color: #1C282D;
					
					tr {
						height: 36px;
						
						td {
							padding: 2px;
							border: 1px solid #E5E0EB;
							text-align: right;
						}
						
						.td-name {
							border-left: none;
							text-align: left;
						}
						
						.td-md {
							padding: 2px 6px;
							border-right: none;
							
							.md_box {
								width: 100%;
								display: flex;
								flex-direction: row;
								justify-content: space-between;
								&__ti {
									padding: 0 4px;
									width: 138px;
									border: none;
									background-color: #ECF4F9;
									line-height: 24px;
								}
								&__sw {
									// width: 44px;
									
								}
							}
						}
					}
				}
			}
			
			// .total {
			// 	text-align: right;
			// 	font-weight: bold;
			// 	text-transform: uppercase;
			// 	span {
			// 		margin-left: 20px;
			// 	}
			// }
		}
		
		.keypad {
			margin: 0 auto;
			border: none;
			margin-bottom: 24px;
		}
		
		.modal-controls {
			justify-content: center;
			gap: 12px;
			
			button {
				width: 180px;
				height: 48px;
				font-style: normal;
				font-weight: 600;
				font-size: 16px;
			}
		}
	}
	
	.switch {
		&_1 {
			--toggle-text-off: #EB262B;
		}
		&_2 {
			--toggle-font-size: 1.5rem;
		}
	}
}
</style>
